import { useEffect, useState } from 'react';
import { createUseTextLocalizer } from '../../../../locale/createUseTextLocalizer';
import bundle from '../../NovaComponents-TokenInput-gui-icu.properties';
const useTextLocalizer = createUseTextLocalizer(bundle);
export const useRequiredTokenInputValidation = ({
  tokenCount = 0,
  required,
  inputValue,
  requiredErrorMessage
}) => {
  const localize = useTextLocalizer();
  const [showError, setShowError] = useState(false);
  const showRequiredError = showError && !!required && tokenCount === 0;
  const [requiredErroTimerFinished, setRequiredErroTimerFinished] = useState(false);
  const delayedShowRequiredError = showRequiredError && requiredErroTimerFinished;
  useEffect(() => {
    if (!showRequiredError) {
      setRequiredErroTimerFinished(false);
      return;
    }

    // This timeout is needed because we don't want the "Required field" error to flash when
    // the user clicks an item in TokenInputDialog which causes the token input to lose the focus
    const timer = setTimeout(() => {
      setRequiredErroTimerFinished(true);
    }, 200);
    return () => clearTimeout(timer);
  }, [showRequiredError]);
  useEffect(() => {
    // Clear the error message when input's value changes or tokenCount is changed
    setShowError(false);
  }, [inputValue, tokenCount]);
  const handleBlur = e => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setShowError(true);
    }
  };
  const status = delayedShowRequiredError ? {
    type: 'alert',
    message: requiredErrorMessage ?? localize('required.error.msg')
  } : undefined;
  return required ? {
    onBlur: handleBlur,
    status
  } : {};
};
//# sourceMappingURL=useRequiredTokenInputValidation.js.map